export default __webpack_public_path__ + "static/media/default_marker.a88d3302.svg";